module.exports = __webpack_public_path__ + "img/karestan-javan.f7c65671.png";